/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_2Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For an initial evaluation, you do not need to install every edition. Try one representative workbook in the environment you expect to use. If the browser sample already reveals a missing requirement, investigate that requirement before spending time configuring another device. If the sample works well, a desktop trial can help you evaluate the repeated open, edit and save routine.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初次评估无需安装所有版本。先在预期使用的环境中测试一个代表性工作簿。如果浏览器示例已经暴露出缺少的关键能力，就先调查该需求，而不必马上配置另一台设备。如果示例表现符合要求，再通过桌面试用检查反复打开、编辑和保存的日常流程。`)
};

/**
* | output |
* | --- |
* | "For an initial evaluation, you do not need to install every edition. Try one representative workbook in the environment you expect to use. If the browser sam..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_6_paragraphs_2 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_2(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_2(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_6_paragraphs_2 as "gc.search_guides.what_is_gridcraft.sections.6.paragraphs.2" }